import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import { ButtonType } from '@/components/CmgButton/cmg-button';
import { OrderWithContext, Reward } from '@/models';
import { AnalyticsEventCategory, AnalyticsEventAction, AnalyticsEventLabel } from '@/services/google/google-analytics.services';

@Component({
  name: 'CmgBagReward',
})
export default class CmgBagReward extends Vue {
  @Prop({ type: Object, required: true })
  reward!: Reward;

  get pointsBalance(): number {
    return this.$services.reward.getPointsBalance();
  }

  get currentOrder(): OrderWithContext | null {
    return this.$store.getters.currentOrder;
  }

  async onClickRedeem() {
    const reward = this.reward;
    const order = this.currentOrder

    if (!order || !reward) {
      return;
    }

    this.$services.googleAnalytics.sendCustomEvent({
      category: AnalyticsEventCategory.ContextualBag,
      action: AnalyticsEventAction.ContextRewardRedeemClick,
      label: AnalyticsEventLabel.ContextRewardRedeemClick,
    });

    this.$services.ui.setAppPepperVisibility(true);
    await this.$services.reward
      .purchaseAndApplyReward(reward.id,order)
      .then(async () => {
        await this.$services.order.refreshOrder(order,true);
        this.$services.ui.setRewardConfirmationVisibility(true);
        this.$services.ui.setBagRewardsToastVisible(true);
      })
      .catch(() => {
        const onClose = () => {
          this.$services.ui.setModalVisibility('basicError', false);
        };

        this.$services.ui.setModalVisibility('basicError', true, {
          header: `OH BUMMER.`,
          content: 'There was an error redeeming your entree, please try again later',
          background: 'white',
          options: [
            {
              text: 'Okay',
              type: ButtonType.Primary,
              onClick: onClose,
            },
          ],
          onClose,
        });
      })
      .finally(() => {
        this.$services.loyalty.refreshPoints(true);
        this.$services.ui.setAppPepperVisibility(false);
        this.onClose();
      });
  }

  onClickTermsAndConditions(event: Event) {
    const reward = this.reward;
    const prevIndex = this.$appStore.state.reward.bagRewards.findIndex((r: Reward) => r.id === reward.id);
    const onBack = () => {
      this.$services.ui.setModalVisibility('bagOffer', true, { prevIndex });
      this.$services.ui.setModalVisibility('rewardTermsAndConditions', false);
    };

    this.$services.ui.pushEventTargetAsLastSelectedElement(event);
    this.$services.ui.setModalVisibility('rewardTermsAndConditions', true, { termsAndConditions: reward.terms, onBack });
    this.$services.ui.firstFocus();
    this.$services.ui.setModalVisibility('bagOffer', false);
  }

  onClose() {
    this.$services.ui.setModalVisibility('bagOffer', false);
  }
}
